import React from 'react';

import {SortHeaderFilter} from '@pb/kit-component-filters';
import {SortDirections} from '@pb/kit-component-sort-header';

import {DateRangeFilterControl} from './date-range-filter-control';


type Props = {
    caption: string,
    idPrefix: string,
    startDate?: string,
    endDate?: string,
    direction?: typeof SortDirections[keyof typeof SortDirections] | null,
    defaultDirection?: typeof SortDirections[keyof typeof SortDirections],
    filterActive?: boolean,
    onSort?: (dir: typeof SortDirections[keyof typeof SortDirections] | null) => void,
    onApply?: () => void,
    onReset?: () => void,
    onCancel?: () => void,
    onStartChange?: (v?: string) => void,
    onEndChange?: (v?: string) => void,
    style?: React.CSSProperties,
};

export const DateColumnFilter = ({
    caption,
    idPrefix,
    startDate,
    endDate,
    direction = null,
    defaultDirection = SortDirections.DESC,
    filterActive = false,
    onSort,
    onApply,
    onReset,
    onCancel,
    onStartChange,
    onEndChange,
    style,
}: Props) => {
    const sortProps = {
        caption,
        sortable: true,
        onApply: onApply || (() => {}),
        onReset: onReset || (() => {}),
        onCancel: onCancel || (() => {}),
        direction: direction ?? undefined,
        defaultDirection: defaultDirection ?? undefined,
        onSort: onSort ?? undefined,
        filterActive: filterActive ?? undefined,
    } as React.ComponentProps<typeof SortHeaderFilter>;

    return (
        <SortHeaderFilter {...sortProps}>
            <DateRangeFilterControl
                idPrefix={idPrefix}
                label={caption}
                startDate={startDate}
                endDate={endDate}
                onStartChange={onStartChange || (() => {})}
                onEndChange={onEndChange || (() => {})}
                style={style}
            />
        </SortHeaderFilter>
    );
};

